var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as constants from "../../constants";
import { isNil, pick } from "lodash";
import { ADDITIONAL_CHAT_STATUS, API_PATH, CALL_TO_ACTION_TYPES, CHAT_STATUS, MESSAGE_STATUS, RICH_TEMPLATE_BUTTON_TYPE, TEMPLATE_RADIO_STATUSES, TEMPLATE_USAGE, LANGUAGES_TYPES, TEMPLATE_FOOTER_MESSAGES, } from "../../constants";
import { action, computed, observable, runInAction, makeObservable, reaction } from "mobx";
import { getAxios } from '../../backend';
import { getProjectId } from "../../settings";
import { EventName, WhatsApp, MessagingChannel, TEMPLATE_HEADER_TYPE, } from "@whatsper/texterchat-common";
import { has4ConsecutiveSpaces, hasTab, hasTwoConsecutiveNewlines } from "../../helpers/string";
import { buildTemplateSendButtons } from "./helpers";
import { message } from "antd";
import i18n from "../../i18n";
/**
 * Minimal timeout between template syncs for account
 */
const TPL_SYNC_MIN_TIMEOUT = 1000 * 60 * 15; // 15 minutes
const DEFAULT_REPLY_ACTION_DURATION_SECONDS = 60 * 60 * 24 * 3; // 72 hours
/**
 * @todo REFACTORING REQUIRED! So far only basic conversion to Typescript done
 */
class TemplateMessagesStore {
    constructor(rootStore) {
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "templateMessagesLists", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "templateMessagesLoading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isNewTemplateDrawer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        //Template Params
        Object.defineProperty(this, "templateTitle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ""
        });
        Object.defineProperty(this, "templateName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ""
        });
        Object.defineProperty(this, "templateUsage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TEMPLATE_USAGE.INBOX
        });
        Object.defineProperty(this, "templateDepartments", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "templateLanguage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: LANGUAGES_TYPES.HE
        });
        Object.defineProperty(this, "templateCategory", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: WhatsApp.TemplateCategory.MARKETING
        });
        Object.defineProperty(this, "templateMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ""
        });
        Object.defineProperty(this, "nextPlaceholderNumber", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 1
        });
        //Template State
        Object.defineProperty(this, "currentTemplate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "templateEditing", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "templateCreating", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "templateDeleting", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        //Advansed Settings
        Object.defineProperty(this, "templateChatStatus", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: CHAT_STATUS.BOT
        });
        Object.defineProperty(this, "templateChatRadioStatus", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TEMPLATE_RADIO_STATUSES.TAKEN
        });
        Object.defineProperty(this, "setBotNode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ""
        });
        Object.defineProperty(this, "selectedBotIdentifier", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "templateReplyText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ""
        });
        Object.defineProperty(this, "templateReplyActionDuration", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: DEFAULT_REPLY_ACTION_DURATION_SECONDS
        });
        Object.defineProperty(this, "responsibleAgent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "responsibleDepartment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "attachedFile", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "botNodeLists", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "botNodeListLoading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "templateFieldMissing", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "isDefaultTemplate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        //Submit params
        Object.defineProperty(this, "submitTemplateLoading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "submitTemplateError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "submitWhatsAppLoading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "submitWhatsAppError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        //Rich template params
        Object.defineProperty(this, "richTemplateHeader", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "richTemplateHeaderType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "richTemplateHeaderUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: constants.DEFAULT_EXAMPLE_TEMPLATE_IMG_URL
        });
        Object.defineProperty(this, "richTemplateFooter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "richTemplateButtonType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "quickReplyButtons", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "callToActionButtons", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "callToActionButtonUrlExamples", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "bodyExampleParams", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "bodyExampleTemporaryParams", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "urlTemporaryParams", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "showManagerCancelModal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        /** Serialized content components of edited template when it was opened */
        Object.defineProperty(this, "contentSnapshot", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "whatsAppFeatures", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "templateTierLimitCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "selectedAccountId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        /**
         * Timestamps when some channel account was last time synchronized with WhatsApp (if was).
         * (Doesn't needs to be observable)
         */
        Object.defineProperty(this, "lastSyncOn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        /**
         * Load template messages for specified WhatsApp account
         *
         * @param accountId WhatsApp account ID
         * @returns
         */
        Object.defineProperty(this, "loadTemplateMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (accountId) => __awaiter(this, void 0, void 0, function* () {
                if (!accountId) {
                    throw new Error('Account ID is required');
                }
                // TODO: Think how to better handle this 
                // /* Load once and update through events  */
                // if (this.templateMessagesLists[accountId]) {
                //     console.debug(`Not loading templates for account ${accountId} because already loaded`);
                //     return;
                // }
                try {
                    runInAction(() => this.templateMessagesLoading = true);
                    const { templates, whatsAppFeatures } = yield this.getTemplateMessages(accountId);
                    runInAction(() => {
                        this.templateMessagesLists[accountId] = templates;
                        this.whatsAppFeatures[accountId] = whatsAppFeatures;
                    });
                }
                catch (error) {
                    console.error("ERROR: loading message templates failed", error);
                }
                finally {
                    runInAction(() => this.templateMessagesLoading = false);
                }
            })
        });
        Object.defineProperty(this, "getTemplateMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (accountId) => __awaiter(this, void 0, void 0, function* () {
                const { data: { templates, whatsAppFeatures } } = yield getAxios()
                    .then((axios) => {
                    return axios.get(`${API_PATH.TEMPLATES}/${accountId}`);
                });
                return {
                    templates: templates
                        .filter((tmp) => { var _a, _b; return ((_b = (_a = tmp.provider_template) === null || _a === void 0 ? void 0 : _a.localizations) === null || _b === void 0 ? void 0 : _b.length) || Object.keys(tmp.localizationDrafts || {}).length; })
                        .sort((tmp1, tmp2) => tmp1.created > tmp2.created ? -1 : 1)
                        .map((tmp) => this.parseTemplate(tmp)),
                    // Server versions before this field was added
                    whatsAppFeatures: whatsAppFeatures !== null && whatsAppFeatures !== void 0 ? whatsAppFeatures : [],
                };
            })
        });
        /**
         * Return already loaded WhatsApp templates for specified WhatsApp account when loaded,
         * or start loading them and return empty array
         *
         * @param accountId
         * @returns
         */
        Object.defineProperty(this, "getOrLoadTemplateMessagesListByAccountId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (accountId) => {
                if (!this.templateMessagesLists[accountId]) {
                    this.loadTemplateMessages(accountId);
                    return [];
                }
                return this.templateMessagesLists[accountId];
            }
        });
        /**
         * Synchronize template messages for specified WhatsApp account with stored templates
         *
         * @param accountId WhatsApp account ID
         * @returns
         */
        Object.defineProperty(this, "syncTemplateMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (accountId) => __awaiter(this, void 0, void 0, function* () {
                if (this.lastSyncOn[accountId] && Date.now() - this.lastSyncOn[accountId] < TPL_SYNC_MIN_TIMEOUT) {
                    console.debug(`Not synchronizing templates for account ${accountId} because was too recently`);
                    return;
                }
                yield getAxios()
                    .then((axios) => {
                    return axios.post(`${API_PATH.TEMPLATES}/${accountId}/sync`);
                })
                    .then(() => {
                    this.lastSyncOn[accountId] = Date.now();
                });
            })
        });
        Object.defineProperty(this, "fetchBotNodeList", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (botName) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                const botNodeKey = botName || 'default';
                /* Don't fetch again bot node list if now < 15 seconds */
                if (((_a = this.botNodeLists[botNodeKey]) === null || _a === void 0 ? void 0 : _a.expiry) > Date.now()) {
                    return;
                }
                runInAction(() => {
                    this.botNodeListLoading = true;
                });
                return yield getAxios()
                    .then((axios) => {
                    return axios.get(`${API_PATH.BOTS}/flow/nodes${botName ? '/' + botName : ''}`);
                })
                    .then(({ data }) => {
                    console.debug('Bot node list fetched', { botName, version: data.version });
                    runInAction(() => {
                        this.botNodeLists[botNodeKey] = {
                            data: data.nodes,
                            expiry: Date.now() + 1000 * 15, // 15 seconds
                        };
                    });
                })
                    .catch(e => console.error(e))
                    .finally(() => {
                    runInAction(() => {
                        this.botNodeListLoading = false;
                    });
                });
            })
        });
        Object.defineProperty(this, "getBotNodeList", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (botName, startableOnly = true) => {
                var _a;
                const botNodeKey = botName || 'default';
                const data = ((_a = this.botNodeLists[botNodeKey]) === null || _a === void 0 ? void 0 : _a.data) || [];
                if (startableOnly) {
                    // For smooth migration apply filter only if there used at least one node marked with `startable` property,
                    // otherwise return all nodes like before
                    const hasMarked = data.some((node) => typeof node.startable === 'boolean');
                    if (hasMarked) {
                        return data.filter((node) => node.startable);
                    }
                }
                return data;
            }
        });
        Object.defineProperty(this, "sendTemplateMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (templateMessage, messageText, parameters) => __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
                const { activeChatStore } = this.rootStore;
                const timestamp = Math.floor(new Date().getTime() / 1000);
                const message = {
                    messageId: `${this.rootStore._new_message_id}_${this.rootStore._new_message_counter++}`,
                    status: MESSAGE_STATUS.MESSAGE_SENT,
                    incoming: false,
                    parent_chat: (_a = this.rootStore.activeChatStore.chat) === null || _a === void 0 ? void 0 : _a._id,
                    received: Date.now(),
                    tmpSendId: timestamp,
                    text: messageText
                };
                const request = {
                    chatId: message.parent_chat,
                    templateMessage: {
                        text: messageText,
                        templateId: templateMessage.name,
                        localization: templateMessage.language,
                        tmpSendId: timestamp,
                        parameters: parameters,
                        chatStatus: CHAT_STATUS.BULK,
                        sendingAgent: (_b = this.rootStore.loginStore.userDetails) === null || _b === void 0 ? void 0 : _b._id,
                        departmentId: (_c = activeChatStore.chat) === null || _c === void 0 ? void 0 : _c.departmentId,
                    }
                };
                if (templateMessage.category === WhatsApp.TemplateCategory.MARKETING) {
                    request.templateMessage.isMarketing = true;
                }
                if (this.templateChatRadioStatus === TEMPLATE_RADIO_STATUSES.TAKEN) {
                    request.templateMessage.chatStatus = CHAT_STATUS.ASSIGNED;
                    request.templateMessage.agent = (_d = this.rootStore.loginStore.userDetails) === null || _d === void 0 ? void 0 : _d._id;
                    request.templateMessage.replyAction = null;
                }
                else {
                    request.templateMessage.replyAction = yield this.createTemplateReplyAction();
                }
                if ([TEMPLATE_HEADER_TYPE.IMAGE, TEMPLATE_HEADER_TYPE.DOCUMENT, TEMPLATE_HEADER_TYPE.VIDEO].includes((_e = templateMessage.header) === null || _e === void 0 ? void 0 : _e.type)) {
                    try {
                        // Composer state only describes the template the agent opened, the default template bar sends without it
                        const isComposerTemplate = ((_f = this.currentTemplate) === null || _f === void 0 ? void 0 : _f._id) === templateMessage._id;
                        const file = isComposerTemplate && this.richTemplateHeader instanceof File ? this.richTemplateHeader : null;
                        const composerUrl = isComposerTemplate ? this.richTemplateHeaderUrl : '';
                        const url = file ? yield this.rootStore.files.uploadFileAndShare(file, this.rootStore.files.getAgentUploadDirectory()) : composerUrl || ((_g = templateMessage.header) === null || _g === void 0 ? void 0 : _g.url);
                        if (url) {
                            request.templateMessage.header = {
                                type: (_h = templateMessage.header) === null || _h === void 0 ? void 0 : _h.type,
                                filename: TEMPLATE_HEADER_TYPE.DOCUMENT === ((_j = templateMessage.header) === null || _j === void 0 ? void 0 : _j.type)
                                    ? (_k = file === null || file === void 0 ? void 0 : file.name) !== null && _k !== void 0 ? _k : (_l = templateMessage.header) === null || _l === void 0 ? void 0 : _l.filename
                                    : void 0,
                                url,
                            };
                        }
                    }
                    catch (error) {
                        console.error('Error uploading file', error);
                        throw new Error('Error uploading file');
                    }
                }
                else if (templateMessage.header && templateMessage.header.type === TEMPLATE_HEADER_TYPE.TEXT && this.richTemplateHeader) {
                    request.templateMessage.header = {
                        type: TEMPLATE_HEADER_TYPE.TEXT,
                        text: this.richTemplateHeader
                    };
                }
                // Send button components only for buttons carrying runtime data; static CTA buttons
                // (static URL / PHONE_NUMBER) come from the approved template and must not be sent.
                if (templateMessage.buttons && templateMessage.buttons.buttons) {
                    const requestButtons = buildTemplateSendButtons(templateMessage.buttons.buttons, this.urlTemporaryParams);
                    if (requestButtons.length > 0) {
                        request.templateMessage.buttons = requestButtons;
                    }
                }
                try {
                    yield getAxios()
                        .then((axios) => {
                        return axios.post(`/templates/send`, request);
                    })
                        .then((response) => {
                        if (!!response && !!response.data && !!response.data.messageId) {
                            message.messageId = response.data.messageId;
                            message.status = constants.MESSAGE_STATUS.MESSAGE_DELIEVERED;
                        }
                        else {
                            message.status = constants.MESSAGE_STATUS.MESSAGE_FAILED;
                        }
                        this.setStoreToDefault();
                    });
                }
                catch (error) {
                    console.error('Sending template message to failed', error);
                    throw new Error(error);
                }
            })
        });
        Object.defineProperty(this, "createTemplateReplyAction", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                const replyAction = {
                    chatStatus: this.templateChatStatus,
                    expirationTime: this.templateReplyActionDuration,
                    resolveTime: Date.now() + this.templateReplyActionDuration * 1000,
                    created: Math.floor(Date.now() / 1000),
                };
                if (this.setBotNode && this.templateChatStatus === CHAT_STATUS.BOT) {
                    replyAction.setBotNode = this.setBotNode;
                }
                else if (!this.setBotNode && this.templateChatStatus === CHAT_STATUS.BOT) {
                    replyAction.setBotNode = "start";
                }
                if (this.selectedBotIdentifier && this.templateChatStatus === CHAT_STATUS.BOT) {
                    replyAction.bot = this.selectedBotIdentifier;
                }
                if (this.templateReplyText && this.templateChatStatus !== CHAT_STATUS.BOT) {
                    replyAction.replyText = this.templateReplyText;
                }
                if (this.attachedFile && !((_a = this.attachedFile) === null || _a === void 0 ? void 0 : _a.url) && this.templateChatStatus !== CHAT_STATUS.BOT) {
                    try {
                        const url = yield this.rootStore.files.uploadFileAndShare(this.attachedFile, this.rootStore.files.getAgentUploadDirectory());
                        replyAction.replyToTemplateFile = {
                            name: this.attachedFile.name,
                            url
                        };
                    }
                    catch (error) {
                        console.error('Error uploading file', error);
                        throw new Error('Error uploading file');
                    }
                }
                else if (this.attachedFile && this.attachedFile.url && this.templateChatStatus !== CHAT_STATUS.BOT) {
                    replyAction.replyToTemplateFile = {
                        name: this.attachedFile.name,
                        url: this.attachedFile.url
                    };
                }
                if (this.responsibleAgent && this.templateChatStatus !== CHAT_STATUS.BOT) {
                    replyAction.responsibleAgent = this.responsibleAgent;
                }
                if (this.responsibleDepartment && this.templateChatStatus !== CHAT_STATUS.BOT) {
                    replyAction.responsibleDepartment = this.responsibleDepartment;
                }
                if ((this.templateChatStatus === CHAT_STATUS.ASSIGNED && !this.responsibleAgent && !this.responsibleDepartment)
                    || this.templateChatStatus === ADDITIONAL_CHAT_STATUS.PENDING_SELF) {
                    replyAction.responsibleAgent = (_b = this.rootStore.loginStore.userDetails) === null || _b === void 0 ? void 0 : _b._id;
                }
                if (this.templateChatStatus === ADDITIONAL_CHAT_STATUS.PENDING_SELF) {
                    replyAction.chatStatus = CHAT_STATUS.ASSIGNED;
                }
                return replyAction;
            })
        });
        Object.defineProperty(this, "createTemplate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => __awaiter(this, void 0, void 0, function* () {
                var _a;
                const accountId = (_a = this.selectedAccountId) === null || _a === void 0 ? void 0 : _a.id;
                if (!accountId) {
                    console.error('No account selected');
                    return;
                }
                try {
                    this.submitTemplateLoading = true;
                    const projectId = yield getProjectId();
                    const templateData = {
                        name: this.templateName.trim(),
                        usage: this.templateUsage,
                        language: this.templateLanguage,
                        category: this.templateCategory,
                        departments: this.templateDepartments,
                        title: this.templateTitle.trim(),
                        chatStatus: this.templateChatStatus,
                        from: projectId,
                        responsibleAgent: null,
                        responsibleDepartment: null,
                        isDefault: this.isDefaultTemplate,
                    };
                    templateData.components = this.createRichTemplateParams();
                    if (this.richTemplateHeaderType && [TEMPLATE_HEADER_TYPE.IMAGE, TEMPLATE_HEADER_TYPE.DOCUMENT, TEMPLATE_HEADER_TYPE.VIDEO].includes(this.richTemplateHeaderType) && this.richTemplateHeader) {
                        const file = this.richTemplateHeader;
                        const fileUrl = yield this.rootStore.files.uploadFileAndShare(file, this.rootStore.files.getAgentUploadDirectory());
                        templateData.components.forEach((component) => {
                            if (component.type === WhatsApp.TemplateComponentType.HEADER) {
                                component.example = {
                                    header_handle: [fileUrl],
                                };
                            }
                        });
                        // document only - send defaults so the original filename is preserved
                        if (this.richTemplateHeaderType === TEMPLATE_HEADER_TYPE.DOCUMENT) {
                            templateData.defaults = this.buildDocumentHeaderDefaults(templateData.components, fileUrl, file.name);
                        }
                    }
                    if (this.templateChatRadioStatus === TEMPLATE_RADIO_STATUSES.TAKEN) {
                        templateData.chatStatus = CHAT_STATUS.PENDING;
                    }
                    else {
                        if (this.templateChatStatus === ADDITIONAL_CHAT_STATUS.PENDING_SELF) {
                            templateData.chatStatus = CHAT_STATUS.ASSIGNED;
                        }
                        else if (this.templateChatStatus !== CHAT_STATUS.BOT) {
                            if (this.responsibleAgent) {
                                templateData.responsibleAgent = this.responsibleAgent;
                            }
                            if (this.responsibleDepartment) {
                                templateData.responsibleDepartment = this.responsibleDepartment;
                            }
                        }
                        if (this.setBotNode) {
                            templateData.setBotNode = this.setBotNode;
                        }
                        if (this.selectedBotIdentifier && this.templateChatStatus === CHAT_STATUS.BOT) {
                            templateData.bot = this.selectedBotIdentifier;
                        }
                        if (this.templateReplyText && this.templateChatStatus !== CHAT_STATUS.BOT) {
                            templateData.replyText = this.templateReplyText;
                        }
                        if (this.attachedFile && this.attachedFile.url && this.templateChatStatus !== CHAT_STATUS.BOT) {
                            templateData.attachedFile = {
                                name: this.attachedFile.name,
                                url: this.attachedFile.url
                            };
                        }
                        else if (this.attachedFile && !this.attachedFile.url && this.templateChatStatus !== CHAT_STATUS.BOT) {
                            const url = yield this.rootStore.files.uploadFileAndShare(this.attachedFile, this.rootStore.files.getAgentUploadDirectory());
                            templateData.attachedFile = {
                                name: this.attachedFile.name,
                                url
                            };
                        }
                    }
                    const templateParams = pick(templateData, [
                        'name',
                        'title',
                        'category',
                        'chatStatus',
                        'departments',
                        'setBotNode',
                        'bot',
                        'responsibleAgent',
                        'responsibleDepartment',
                        'replyText',
                        'usage',
                        'isDefault',
                    ]);
                    const templateLocalizations = pick(templateData, [
                        'language',
                        'components',
                        'defaults',
                    ]);
                    const axios = yield getAxios();
                    const { data: template } = yield axios.post(`${API_PATH.TEMPLATES}/${accountId}`, templateParams);
                    try {
                        yield axios.post(`${API_PATH.TEMPLATES}/${accountId}/${template.name}/localizations`, templateLocalizations);
                    }
                    catch (error) {
                        // Temporary fix
                        // Try to delete newly added template without localizations
                        try {
                            yield axios.delete(`${API_PATH.TEMPLATES}/${accountId}/${template.name}`);
                        }
                        catch (error) {
                            console.error(error);
                        }
                        throw error;
                    }
                    this.setStoreToDefault();
                    return true;
                }
                catch (error) {
                    runInAction(() => {
                        this.submitTemplateError = error.message;
                        this.submitTemplateLoading = false;
                    });
                    throw error;
                }
            })
        });
        Object.defineProperty(this, "toggleNewTemplateDrawer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.isNewTemplateDrawer = !this.isNewTemplateDrawer;
            }
        });
        Object.defineProperty(this, "handleEditTemplate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (...args_1) => __awaiter(this, [...args_1], void 0, function* ({ skipReset = false } = {}) {
                var _a, _b;
                const accountId = (_a = this.selectedAccountId) === null || _a === void 0 ? void 0 : _a.id;
                if (!accountId) {
                    console.error('No account selected');
                    return;
                }
                try {
                    let templateData = {
                        title: this.templateTitle.trim(),
                        departments: this.templateDepartments,
                        category: this.templateCategory,
                        message: this.templateMessage,
                        language: this.templateLanguage,
                        usage: this.templateUsage,
                        chatStatus: this.templateChatStatus,
                        responsibleAgent: null,
                        responsibleDepartment: null,
                        isDefault: this.isDefaultTemplate,
                    };
                    this.submitTemplateLoading = true;
                    templateData.components = this.createRichTemplateParams();
                    if (this.richTemplateHeaderType && [TEMPLATE_HEADER_TYPE.IMAGE, TEMPLATE_HEADER_TYPE.DOCUMENT, TEMPLATE_HEADER_TYPE.VIDEO].includes(this.richTemplateHeaderType)) {
                        const file = this.richTemplateHeader;
                        if (this.richTemplateHeader) {
                            const fileUrl = yield this.rootStore.files.uploadFileAndShare(file, this.rootStore.files.getAgentUploadDirectory());
                            templateData.components.forEach((component) => {
                                if (component.type === WhatsApp.TemplateComponentType.HEADER) {
                                    component.example = {
                                        header_handle: [fileUrl],
                                    };
                                }
                            });
                            // document only - send defaults so the original filename is preserved
                            if (this.richTemplateHeaderType === TEMPLATE_HEADER_TYPE.DOCUMENT) {
                                templateData.defaults = this.buildDocumentHeaderDefaults(templateData.components, fileUrl, file.name);
                            }
                        }
                    }
                    if (this.templateChatRadioStatus === TEMPLATE_RADIO_STATUSES.TAKEN) {
                        templateData.chatStatus = CHAT_STATUS.PENDING;
                    }
                    else {
                        if (this.templateChatStatus === ADDITIONAL_CHAT_STATUS.PENDING_SELF) {
                            templateData.chatStatus = CHAT_STATUS.ASSIGNED;
                        }
                        else if (this.templateChatStatus !== CHAT_STATUS.BOT) {
                            if (this.responsibleAgent) {
                                templateData.responsibleAgent = this.responsibleAgent;
                            }
                            if (this.responsibleDepartment) {
                                templateData.responsibleDepartment = this.responsibleDepartment;
                            }
                        }
                        if (this.setBotNode) {
                            templateData.setBotNode = this.setBotNode;
                        }
                        if (this.selectedBotIdentifier && this.templateChatStatus === CHAT_STATUS.BOT) {
                            templateData.bot = this.selectedBotIdentifier;
                        }
                        if (this.templateReplyText && this.templateChatStatus !== CHAT_STATUS.BOT) {
                            templateData.replyText = this.templateReplyText;
                        }
                        if (this.attachedFile && this.attachedFile.url && this.templateChatStatus !== CHAT_STATUS.BOT) {
                            templateData.attachedFile = {
                                name: this.attachedFile.name,
                                url: this.attachedFile.url
                            };
                        }
                        else if (this.attachedFile && !this.attachedFile.url && this.templateChatStatus !== CHAT_STATUS.BOT) {
                            const url = yield this.rootStore.files.uploadFileAndShare(this.attachedFile, this.rootStore.files.getAgentUploadDirectory());
                            templateData.attachedFile = {
                                name: this.attachedFile.name,
                                url
                            };
                        }
                    }
                    const templateParams = pick(templateData, [
                        'title',
                        'chatStatus',
                        'departments',
                        'setBotNode',
                        'bot',
                        'responsibleAgent',
                        'responsibleDepartment',
                        'replyText',
                        'usage',
                        'isDefault',
                    ]);
                    let templateLocalization;
                    if (!this.isTemplateSubmitted || (this.isLocalizationEditable && this.hasContentChanges)) {
                        templateLocalization = pick(templateData, [
                            'language',
                            'components',
                            'defaults',
                        ]);
                    }
                    const axios = yield getAxios();
                    yield axios.patch(`${API_PATH.TEMPLATES}/${accountId}/${(_b = this.currentTemplate) === null || _b === void 0 ? void 0 : _b.name}`, templateParams)
                        .then((_a) => __awaiter(this, [_a], void 0, function* ({ data }) {
                        if (templateLocalization) {
                            return axios.post(`${API_PATH.TEMPLATES}/${accountId}/${data.name}/localizations`, templateLocalization);
                        }
                    }));
                    if (skipReset) {
                        runInAction(() => {
                            this.submitTemplateLoading = false;
                        });
                    }
                    else {
                        this.setStoreToDefault();
                    }
                }
                catch (error) {
                    runInAction(() => {
                        this.submitTemplateError = error.message;
                        this.submitTemplateLoading = false;
                    });
                    throw error;
                }
            })
        });
        Object.defineProperty(this, "handleDeleteTemplate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const accountId = (_a = this.selectedAccountId) === null || _a === void 0 ? void 0 : _a.id;
                if (!accountId) {
                    console.error('No account selected');
                    return;
                }
                const name = ((_b = this.currentTemplate) === null || _b === void 0 ? void 0 : _b.obj.templateId) || ((_c = this.currentTemplate) === null || _c === void 0 ? void 0 : _c.name);
                this.submitTemplateLoading = true;
                try {
                    yield getAxios()
                        .then((axios) => {
                        return axios.delete(`${API_PATH.TEMPLATES}/${accountId}/${name}`);
                    });
                    this.setStoreToDefault();
                }
                catch (error) {
                    console.error(error);
                }
                finally {
                    runInAction(() => {
                        this.submitTemplateLoading = false;
                    });
                }
            })
        });
        Object.defineProperty(this, "handleSubmitToWhatsApp", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => __awaiter(this, void 0, void 0, function* () {
                var _a;
                const accountId = (_a = this.selectedAccountId) === null || _a === void 0 ? void 0 : _a.id;
                if (!accountId) {
                    console.error('No account selected');
                    return;
                }
                this.submitWhatsAppLoading = true;
                this.submitWhatsAppError = null;
                const errorKey = this.checkTemplateForErrorsBeforeSubmit();
                if (errorKey) {
                    runInAction(() => {
                        this.submitWhatsAppLoading = false;
                    });
                    message.error(i18n.t(errorKey), 5);
                    return;
                }
                return yield getAxios()
                    .then((axios) => {
                    var _a;
                    return axios.post(`${API_PATH.TEMPLATES}/${accountId}/${(_a = this.currentTemplate) === null || _a === void 0 ? void 0 : _a.name}/localizations/${this.templateLanguage}/submit`);
                })
                    .then(() => {
                    runInAction(() => {
                        var _a;
                        const index = (_a = this.templateMessagesLists[accountId]) === null || _a === void 0 ? void 0 : _a.findIndex(templ => { var _a; return templ.name === ((_a = this.currentTemplate) === null || _a === void 0 ? void 0 : _a.name); });
                        this.templateMessagesLists[accountId][index].obj.localizations[0].status = WhatsApp.Templates.Localizations.Status.PENDING;
                    });
                    this.setStoreToDefault();
                    message.success(i18n.t('submitTemplateSuccess'), 5);
                })
                    .catch((e) => {
                    // Public error from server, e.g. WhatsApp rejection reason
                    message.error(e.message || i18n.t('unexpectedError'), 5);
                    console.error(e);
                })
                    .finally(() => {
                    runInAction(() => {
                        this.submitWhatsAppLoading = false;
                    });
                });
            })
        });
        Object.defineProperty(this, "saveAndSubmitToWhatsApp", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => __awaiter(this, void 0, void 0, function* () {
                const errorKey = this.checkTemplateForErrorsBeforeSubmit();
                if (errorKey) {
                    message.error(i18n.t(errorKey), 5);
                    return;
                }
                if (this.templateEditing) {
                    yield this.handleEditTemplate({ skipReset: true });
                }
                yield this.handleSubmitToWhatsApp();
            })
        });
        Object.defineProperty(this, "checkTemplateForErrorsBeforeSubmit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (!this.hasAllSampleParamsAdded) {
                    return 'pleaseProvideSampleData';
                }
                if (hasTwoConsecutiveNewlines(this.templateMessage)) {
                    return 'templateTooManyConsecutiveNewlines';
                }
                if (has4ConsecutiveSpaces(this.templateMessage)) {
                    return 'has4ConsecutiveSpacesOrNewLines';
                }
                if (hasTab(this.templateMessage)) {
                    return 'hasTabChar';
                }
                if (this.richTemplateHeaderType === TEMPLATE_HEADER_TYPE.TEXT && !this.richTemplateHeader) {
                    return 'headerTextEmpty';
                }
            }
        });
        Object.defineProperty(this, "checkTemplateForErrorsBeforeEdit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (this.richTemplateHeaderType === TEMPLATE_HEADER_TYPE.TEXT && !this.richTemplateHeader) {
                    return 'headerTextEmpty';
                }
            }
        });
        Object.defineProperty(this, "getTierLimit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                const accountId = (_a = this.selectedAccountId) === null || _a === void 0 ? void 0 : _a.id;
                if (!accountId) {
                    console.error('No account selected');
                    return;
                }
                try {
                    const axios = yield getAxios();
                    if (((_b = this.selectedAccountId) === null || _b === void 0 ? void 0 : _b.name) === MessagingChannel.whatsapp) {
                        const response = yield axios.get(`${API_PATH.CHANNELS}/accounts/whatsapp/${accountId}/templates/limit`);
                        runInAction(() => {
                            this.templateTierLimitCount = response.data.limit;
                        });
                    }
                }
                catch (error) {
                    console.error('Error getting tier limit', error);
                    return null;
                }
            })
        });
        Object.defineProperty(this, "createRichTemplateParams", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                var _a;
                const richParams = [];
                if (this.richTemplateHeaderType) {
                    const header = {
                        type: WhatsApp.TemplateComponentType.HEADER,
                        format: this.richTemplateHeaderType,
                    };
                    if (this.richTemplateHeaderType === TEMPLATE_HEADER_TYPE.TEXT) {
                        header.text = this.richTemplateHeader;
                    }
                    if (this.richTemplateHeaderType &&
                        [TEMPLATE_HEADER_TYPE.IMAGE, TEMPLATE_HEADER_TYPE.DOCUMENT, TEMPLATE_HEADER_TYPE.VIDEO].includes(this.richTemplateHeaderType) &&
                        this.richTemplateHeaderUrl &&
                        this.richTemplateHeaderUrl !== constants.DEFAULT_EXAMPLE_TEMPLATE_IMG_URL) {
                        header.example = {
                            header_handle: [this.richTemplateHeaderUrl],
                        };
                    }
                    richParams.push(header);
                }
                const body = {
                    type: WhatsApp.TemplateComponentType.BODY,
                    text: this.templateMessage,
                };
                if (((_a = this.bodyExampleParams) === null || _a === void 0 ? void 0 : _a.filter(p => p !== null).length) > 0
                    && !(this.bodyExampleParams.length < this.nextPlaceholderNumber - 1)) {
                    body.example = {
                        body_text: [this.bodyExampleParams],
                    };
                }
                richParams.push(body);
                if (this.richTemplateFooter) {
                    const footer = {
                        type: WhatsApp.TemplateComponentType.FOOTER,
                        text: this.richTemplateFooter,
                    };
                    richParams.push(footer);
                }
                if (this.quickReplyButtons || this.callToActionButtons) {
                    const buttons = { type: WhatsApp.TemplateComponentType.BUTTONS, buttons: [] };
                    if (this.quickReplyButtons) {
                        this.quickReplyButtons.map(({ text }) => {
                            buttons.buttons.push({
                                type: WhatsApp.TemplateButtonType.QUICK_REPLY,
                                text,
                            });
                        });
                    }
                    ;
                    if (this.callToActionButtons) {
                        this.callToActionButtons.map(({ type, text, url, phone_number }, index) => {
                            if (phone_number) {
                                buttons.buttons.push({ type, text, phone_number });
                            }
                            if (url) {
                                let buttonLocalUrl = url;
                                const placeholders = url.match(/{{(\d+)}}/g) || [];
                                placeholders.forEach((placeholder, idx) => {
                                    const buttonLocalPlaceholder = `{{${idx + 1}}}`;
                                    buttonLocalUrl = buttonLocalUrl.replace(placeholder, buttonLocalPlaceholder);
                                });
                                const buttonData = { type, text, url: buttonLocalUrl };
                                // Add URL example if URL contains placeholder and example is provided
                                if (url.match(/{{.*?}}/g) && this.callToActionButtonUrlExamples[index]) {
                                    buttonData.example = {
                                        url: this.callToActionButtonUrlExamples[index]
                                    };
                                }
                                buttons.buttons.push(buttonData);
                            }
                        });
                    }
                    richParams.push(buttons);
                }
                return richParams;
            }
        });
        Object.defineProperty(this, "buildDocumentHeaderDefaults", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (components, url, filename) => {
                var _a, _b, _c;
                const defaults = {
                    header: {
                        type: WhatsApp.TemplateHeaderSendType.DOCUMENT,
                        url,
                        filename,
                    },
                };
                const bodyExample = (_c = (_b = (_a = components.find((component) => component.type === WhatsApp.TemplateComponentType.BODY)) === null || _a === void 0 ? void 0 : _a.example) === null || _b === void 0 ? void 0 : _b.body_text) === null || _c === void 0 ? void 0 : _c[0];
                if (bodyExample) {
                    defaults.body = bodyExample;
                }
                return defaults;
            }
        });
        /**
         * @todo Rewrite this because looks awful
         *
         * @param agent
         * @param departmentId
         */
        Object.defineProperty(this, "setResponsibleAgentOrDepartment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (agent, departmentId) => {
                var _a;
                this.templateFieldMissing = null;
                if (agent) {
                    this.responsibleAgent = agent;
                    this.responsibleDepartment = null;
                }
                else {
                    this.responsibleAgent = null;
                    this.responsibleDepartment = ((_a = this.rootStore.departmentsStore.departments.find(department => department._id === departmentId)) === null || _a === void 0 ? void 0 : _a._id) || null;
                }
            }
        });
        Object.defineProperty(this, "setAttachedFile", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (file) => {
                this.attachedFile = file;
            }
        });
        Object.defineProperty(this, "setNewTemplate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.templateCreating = !this.templateCreating;
            }
        });
        Object.defineProperty(this, "setTemplateEdited", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (template) => {
                var _a;
                if (template) {
                    const chatStatus = template.chatStatus || CHAT_STATUS.BOT;
                    const placeholderNumber = (((_a = template.text.match(/{{(.*?)}}/g)) === null || _a === void 0 ? void 0 : _a.length) || 0) + 1;
                    this.currentTemplate = template;
                    this.templateEditing = true;
                    this.templateCreating = false;
                    this.templateTitle = template.title;
                    this.templateUsage = template.usage;
                    this.templateDepartments = template.departments;
                    this.templateLanguage = template.language;
                    this.templateCategory = template.category;
                    this.templateMessage = template.text;
                    this.bodyExampleParams = [];
                    this.nextPlaceholderNumber = placeholderNumber || 1;
                    this.isDefaultTemplate = !!template.isDefault;
                    template.obj.localizations[0].components.forEach((component) => {
                        var _a;
                        if (component.type === WhatsApp.TemplateComponentType.BODY && component.example) {
                            this.bodyExampleParams = (_a = component.example.body_text) === null || _a === void 0 ? void 0 : _a[0];
                        }
                    });
                    if (chatStatus === CHAT_STATUS.ASSIGNED && !(template.responsibleAgent || template.responsibleDepartment)) {
                        this.templateChatStatus = ADDITIONAL_CHAT_STATUS.PENDING_SELF;
                        this.responsibleAgent = null;
                        this.responsibleDepartment = null;
                    }
                    else {
                        this.templateChatStatus = chatStatus;
                        if (template.responsibleAgent) {
                            this.responsibleAgent = template.responsibleAgent;
                        }
                        else {
                            this.responsibleAgent = null;
                        }
                        if (template.responsibleDepartment) {
                            this.responsibleDepartment = template.responsibleDepartment;
                        }
                        else {
                            this.responsibleDepartment = null;
                        }
                    }
                    if (chatStatus !== CHAT_STATUS.PENDING) {
                        this.templateChatRadioStatus = TEMPLATE_RADIO_STATUSES.OTHER;
                    }
                    else
                        this.templateChatRadioStatus = TEMPLATE_RADIO_STATUSES.TAKEN;
                    if (template.replyText) {
                        this.templateReplyText = template.replyText;
                    }
                    else
                        this.templateReplyText = "";
                    if (template.setBotNode) {
                        this.setBotNode = template.setBotNode;
                    }
                    else
                        this.setBotNode = null;
                    if (template.bot) {
                        this.selectedBotIdentifier = template.bot;
                        this.fetchBotNodeList(template.bot);
                    }
                    else {
                        const channelDefault = this.selectedChannelBot;
                        this.selectedBotIdentifier = channelDefault !== null && channelDefault !== void 0 ? channelDefault : null;
                        if (channelDefault) {
                            this.fetchBotNodeList(channelDefault);
                        }
                    }
                    if (template.attachedFile) {
                        this.attachedFile = template.attachedFile;
                    }
                    else
                        this.attachedFile = null;
                    if (this.rootStore.wizardStore.isWizardOpen) {
                        this.templateChatRadioStatus = TEMPLATE_RADIO_STATUSES.OTHER;
                    }
                    if (template.header) {
                        this.richTemplateHeaderType = template.header.type;
                        this.richTemplateHeaderUrl = template.header.url || '';
                        this.richTemplateHeader = template.header.text || null;
                    }
                    if (template.footer) {
                        this.richTemplateFooter = template.footer.text;
                    }
                    if (template.buttons) {
                        if (template.buttons.buttons[0] && template.buttons.buttons[0].type === RICH_TEMPLATE_BUTTON_TYPE.QUICK_REPLY) {
                            this.richTemplateButtonType = RICH_TEMPLATE_BUTTON_TYPE.QUICK_REPLY;
                            this.quickReplyButtons = template.buttons.buttons;
                        }
                        else {
                            this.richTemplateButtonType = RICH_TEMPLATE_BUTTON_TYPE.CALL_TO_ACTION;
                            this.callToActionButtons = template.buttons.buttons;
                            // Extract URL examples from existing buttons
                            this.callToActionButtonUrlExamples = [];
                            template.obj.localizations[0].components.forEach((component) => {
                                if (component.type === WhatsApp.TemplateComponentType.BUTTONS) {
                                    component.buttons.forEach((button, index) => {
                                        if (button.type === CALL_TO_ACTION_TYPES.URL && button.example) {
                                            if (button.example.url) {
                                                this.callToActionButtonUrlExamples[index] = button.example.url;
                                            }
                                            else if (Array.isArray(button.example) && button.example[0]) {
                                                this.callToActionButtonUrlExamples[index] = button.example[0];
                                            }
                                        }
                                    });
                                }
                            });
                        }
                    }
                    this.contentSnapshot = JSON.stringify(this.createRichTemplateParams());
                }
            }
        });
        Object.defineProperty(this, "setTemplateDeleting", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (template) => {
                this.currentTemplate = template;
                this.templateDeleting = !this.templateDeleting;
            }
        });
        Object.defineProperty(this, "handleSetUsage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                var _a;
                this.templateUsage = value;
                if (value === TEMPLATE_USAGE.BULK) {
                    this.handleSetRadioStatus(TEMPLATE_RADIO_STATUSES.OTHER);
                    if (((_a = this.currentTemplate) === null || _a === void 0 ? void 0 : _a.status) !== WhatsApp.Templates.Localizations.Status.APPROVED) {
                        this.richTemplateFooter = TEMPLATE_FOOTER_MESSAGES[this.templateLanguage] || '';
                    }
                }
                else {
                    this.handleSetRadioStatus(TEMPLATE_RADIO_STATUSES.TAKEN);
                }
            }
        });
        Object.defineProperty(this, "handleSetTemplateLanguage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                this.templateLanguage = value;
            }
        });
        Object.defineProperty(this, "handleSetCategory", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                this.templateCategory = value;
            }
        });
        Object.defineProperty(this, "handleSetDepartment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                this.templateDepartments = value;
            }
        });
        Object.defineProperty(this, "handleCheckIfSampleParamsHaveBeenAdded", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (hasAllSampleParamsAdded) => {
                const canSaveDraftWithoutDocument = this.templateEditing &&
                    this.richTemplateHeaderType === TEMPLATE_HEADER_TYPE.DOCUMENT &&
                    !this.hasDocumentSample;
                this.submitTemplateError =
                    hasAllSampleParamsAdded || canSaveDraftWithoutDocument
                        ? null
                        : 'provideSampleData';
                this.submitWhatsAppError = hasAllSampleParamsAdded
                    ? null
                    : 'provideSampleData';
            }
        });
        Object.defineProperty(this, "handleSetMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (message) => {
                var _a;
                const listOfPlaceholders = message.match(/{{(.*?)}}/g);
                let nextPlaceholderNumber;
                if (listOfPlaceholders) {
                    nextPlaceholderNumber = listOfPlaceholders.length + 1;
                }
                else {
                    nextPlaceholderNumber = 1;
                }
                this.templateMessage = message;
                this.nextPlaceholderNumber = nextPlaceholderNumber;
                if (((_a = this.bodyExampleParams) === null || _a === void 0 ? void 0 : _a.length) > nextPlaceholderNumber - 1) {
                    this.bodyExampleParams = this.bodyExampleParams.slice(0, nextPlaceholderNumber - 1);
                }
            }
        });
        Object.defineProperty(this, "handleAddPlaceholder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (start, end) => {
                const listOfPlaceholders = this.templateMessage.match(/{{(.*?)}}/g);
                // Count all URL placeholders across all buttons
                let dynamicLinkCounter = 0;
                if (this.callToActionButtons) {
                    this.callToActionButtons.forEach(button => {
                        if (button.url && button.url.match(/{{(.*?)}}/g)) {
                            const urlPlaceholders = button.url.match(/{{(.*?)}}/g);
                            dynamicLinkCounter += urlPlaceholders.length;
                        }
                    });
                }
                if (listOfPlaceholders) {
                    this.nextPlaceholderNumber = listOfPlaceholders.length + 1 + dynamicLinkCounter;
                }
                const stringEnd = this.templateMessage.length;
                this.templateMessage = `${this.templateMessage.slice(0, start)}{{${this.nextPlaceholderNumber}}}${this.templateMessage.slice(end, stringEnd)}`;
                this.nextPlaceholderNumber += 1;
            }
        });
        Object.defineProperty(this, "handleAddEmoji", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (emoji, start, end) => {
                const stringEnd = this.templateMessage.length;
                this.templateMessage = `${this.templateMessage.slice(0, start)}${emoji}${this.templateMessage.slice(end, stringEnd)}`;
            }
        });
        Object.defineProperty(this, "handleSetTitle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                this.templateTitle = value;
            }
        });
        Object.defineProperty(this, "setTemplateName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (name) => {
                // Template ID cannot contain capital letters per whatsapp, user is warned in the UI
                this.templateName = name.toLowerCase();
            }
        });
        Object.defineProperty(this, "handleSetStatus", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (templateChatStatus) => {
                this.templateFieldMissing = false;
                this.templateChatStatus = templateChatStatus;
            }
        });
        Object.defineProperty(this, "setTemplateReplyActionDuration", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (durationSeconds) => {
                this.templateReplyActionDuration = durationSeconds;
            }
        });
        Object.defineProperty(this, "handleSetRadioStatus", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (radioStatus) => {
                this.templateChatRadioStatus = radioStatus;
                if (radioStatus === TEMPLATE_RADIO_STATUSES.OTHER) {
                    if (this.templateChatStatus === CHAT_STATUS.RESOLVED) {
                        this.templateChatStatus = CHAT_STATUS.RESOLVED;
                    }
                    else if (this.responsibleAgent || this.responsibleDepartment) {
                        this.templateChatStatus = CHAT_STATUS.ASSIGNED;
                    }
                    else {
                        this.templateChatStatus = CHAT_STATUS.BOT;
                    }
                }
                else if (radioStatus === TEMPLATE_RADIO_STATUSES.TAKEN) {
                    this.templateChatStatus = CHAT_STATUS.ASSIGNED;
                }
            }
        });
        Object.defineProperty(this, "handleSetBotNode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                this.setBotNode = value;
            }
        });
        Object.defineProperty(this, "handleSelectBot", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (botIdentifier) => __awaiter(this, void 0, void 0, function* () {
                this.selectedBotIdentifier = botIdentifier;
                if (!botIdentifier) {
                    this.setBotNode = null;
                    return;
                }
                yield this.ensureBotNodeList(botIdentifier);
                runInAction(() => {
                    this.setBotNode = this.resolveStartNodeName(botIdentifier);
                });
            })
        });
        /**
         * Apply a bot to the current template's reply settings.
         * Called after creating a MiniBot to auto-configure the template to use it.
         */
        Object.defineProperty(this, "applyBotToReplySettings", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (botIdentifier) => __awaiter(this, void 0, void 0, function* () {
                this.selectedBotIdentifier = botIdentifier;
                this.templateChatStatus = CHAT_STATUS.BOT;
                yield this.ensureBotNodeList(botIdentifier);
                runInAction(() => {
                    this.setBotNode = this.resolveStartNodeName(botIdentifier);
                });
            })
        });
        Object.defineProperty(this, "ensureBotNodeList", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (botIdentifier) => __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                if ((_b = (_a = this.botNodeLists[botIdentifier]) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.length)
                    return;
                yield this.fetchBotNodeList(botIdentifier);
            })
        });
        Object.defineProperty(this, "resolveStartNodeName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (botIdentifier) => {
                var _a, _b;
                const nodes = this.getBotNodeList(botIdentifier);
                return (_b = (_a = nodes[0]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : 'start';
            }
        });
        Object.defineProperty(this, "handleSetReplyText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                // this.templateFieldMissing = null
                this.templateReplyText = value;
            }
        });
        Object.defineProperty(this, "addEmojiToReply", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (emoji, start, end) => {
                const stringEnd = this.templateReplyText.length;
                this.templateReplyText = `${this.templateReplyText.slice(0, start)}${emoji}${this.templateReplyText.slice(end, stringEnd)}`;
            }
        });
        Object.defineProperty(this, "setStoreToDefault", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.templateTitle = "";
                this.templateName = "";
                this.templateUsage = TEMPLATE_USAGE.INBOX;
                this.templateDepartments = [];
                this.templateLanguage = LANGUAGES_TYPES.HE;
                this.templateCategory = WhatsApp.TemplateCategory.MARKETING;
                this.templateMessage = "";
                this.nextPlaceholderNumber = 1;
                this.attachedFile = null;
                this.bodyExampleParams = [];
                this.bodyExampleTemporaryParams = [];
                this.urlTemporaryParams = [];
                this.currentTemplate = null;
                this.templateEditing = false;
                this.templateCreating = false;
                this.templateDeleting = false;
                this.submitTemplateLoading = false;
                this.submitTemplateError = null;
                this.submitWhatsAppError = null;
                this.submitWhatsAppLoading = false;
                this.templateChatStatus = CHAT_STATUS.BOT;
                this.templateChatRadioStatus = TEMPLATE_RADIO_STATUSES.TAKEN;
                this.setBotNode = "";
                this.selectedBotIdentifier = null;
                this.templateReplyText = "";
                this.templateReplyActionDuration = DEFAULT_REPLY_ACTION_DURATION_SECONDS;
                this.responsibleAgent = null;
                this.responsibleDepartment = null;
                this.richTemplateHeader = null;
                this.richTemplateHeaderType = null;
                this.richTemplateHeaderUrl = constants.DEFAULT_EXAMPLE_TEMPLATE_IMG_URL;
                this.richTemplateFooter = null;
                this.richTemplateButtonType = null;
                this.quickReplyButtons = null;
                this.callToActionButtons = null;
                this.callToActionButtonUrlExamples = [];
                this.contentSnapshot = null;
                this.lastSyncOn = {};
            }
        });
        Object.defineProperty(this, "setFieldError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.templateFieldMissing = true;
            }
        });
        //Rich template params functions
        Object.defineProperty(this, "handleRichTemplateHeaderType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                this.richTemplateHeaderType = value;
            }
        });
        Object.defineProperty(this, "handleSetHeader", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                if (typeof value !== "string") {
                    this.richTemplateHeader = value[0];
                }
                else {
                    this.richTemplateHeader = value;
                }
            }
        });
        Object.defineProperty(this, "clearRichTemplateHeaderFile", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.richTemplateHeader = null;
                this.richTemplateHeaderUrl = '';
                this.showManagerCancelModal = true;
            }
        });
        Object.defineProperty(this, "handleSetFooter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                this.richTemplateFooter = value;
            }
        });
        Object.defineProperty(this, "handleSetButtonType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                if (value === RICH_TEMPLATE_BUTTON_TYPE.QUICK_REPLY) {
                    this.callToActionButtons = null;
                    this.callToActionButtonUrlExamples = [];
                    this.quickReplyButtons = [{ text: "" }];
                }
                else if (value === RICH_TEMPLATE_BUTTON_TYPE.CALL_TO_ACTION) {
                    this.quickReplyButtons = null;
                    this.callToActionButtons = [{ type: CALL_TO_ACTION_TYPES.URL, text: "", url: "" }];
                    this.callToActionButtonUrlExamples = [""];
                }
                else {
                    this.callToActionButtons = null;
                    this.quickReplyButtons = null;
                    this.callToActionButtonUrlExamples = [];
                }
                this.richTemplateButtonType = value;
            }
        });
        Object.defineProperty(this, "handleAddButton", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (type, actionType) => {
                if (type === RICH_TEMPLATE_BUTTON_TYPE.QUICK_REPLY) {
                    this.quickReplyButtons = [...this.quickReplyButtons, { text: "" }];
                }
                else if (type === RICH_TEMPLATE_BUTTON_TYPE.CALL_TO_ACTION) {
                    this.callToActionButtons = [...this.callToActionButtons, { type: actionType === CALL_TO_ACTION_TYPES.URL ? CALL_TO_ACTION_TYPES.PHONE_NUMBER : CALL_TO_ACTION_TYPES.URL, text: "", url: "" }];
                    this.callToActionButtonUrlExamples = [...this.callToActionButtonUrlExamples, ""];
                }
            }
        });
        Object.defineProperty(this, "handleRemoveButton", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (type, index) => {
                if (type === RICH_TEMPLATE_BUTTON_TYPE.QUICK_REPLY) {
                    const list = [...this.quickReplyButtons];
                    list.splice(index, 1);
                    this.quickReplyButtons = list;
                }
                else if (type === RICH_TEMPLATE_BUTTON_TYPE.CALL_TO_ACTION) {
                    const list = [...this.callToActionButtons];
                    list.splice(index, 1);
                    this.callToActionButtons = list;
                    const examples = [...this.callToActionButtonUrlExamples];
                    examples.splice(index, 1);
                    this.callToActionButtonUrlExamples = examples;
                }
            }
        });
        Object.defineProperty(this, "handleButtonTextChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value, index, type, fieldName) => {
                if (type === RICH_TEMPLATE_BUTTON_TYPE.QUICK_REPLY) {
                    const list = [...this.quickReplyButtons];
                    list[index][fieldName] = value;
                    this.quickReplyButtons = list;
                }
                else if (type === RICH_TEMPLATE_BUTTON_TYPE.CALL_TO_ACTION) {
                    const list = [...this.callToActionButtons];
                    list[index][fieldName] = value;
                    this.callToActionButtons = list;
                    if (fieldName === "url" && new RegExp(/{{(.*?)}}/g).test(value)) {
                        this.templateUsage = TEMPLATE_USAGE.BULK;
                    }
                }
            }
        });
        Object.defineProperty(this, "handleAddPlaceholderToUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (buttonIndex) => {
                // Count body placeholders
                const listOfPlaceholders = this.templateMessage.match(/{{(.*?)}}/g);
                let nextPlaceholderNumber = listOfPlaceholders ? listOfPlaceholders.length + 1 : 1;
                // Count existing URL placeholders across all buttons
                let dynamicLinkCounter = 0;
                if (this.callToActionButtons) {
                    this.callToActionButtons.forEach(button => {
                        if (button.url && button.url.match(/{{(.*?)}}/g)) {
                            const urlPlaceholders = button.url.match(/{{(.*?)}}/g);
                            dynamicLinkCounter += urlPlaceholders.length;
                        }
                    });
                }
                // Add URL placeholder count to get the next sequential number
                nextPlaceholderNumber += dynamicLinkCounter;
                const list = [...this.callToActionButtons];
                list[buttonIndex].url = (list[buttonIndex].url || '') + `{{${nextPlaceholderNumber}}}`;
                this.callToActionButtons = list;
                this.templateUsage = TEMPLATE_USAGE.BULK;
            }
        });
        Object.defineProperty(this, "handleSetUrlExample", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (buttonIndex, value) => {
                const examples = [...this.callToActionButtonUrlExamples];
                examples[buttonIndex] = value;
                this.callToActionButtonUrlExamples = examples;
            }
        });
        Object.defineProperty(this, "changeTempExampleParam", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (index, value) => {
                const params = [...this.bodyExampleTemporaryParams];
                params[index] = value;
                this.bodyExampleTemporaryParams = params;
            }
        });
        Object.defineProperty(this, "changeConsolidatedParam", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (paramInfo, value) => {
                if (paramInfo.type === 'body') {
                    this.changeTempExampleParam(paramInfo.index, value);
                }
                else if (paramInfo.type === 'url') {
                    // Store URL parameter values by placeholder number (not button index)
                    const params = [...this.urlTemporaryParams];
                    params[paramInfo.placeholderNum - 1] = value;
                    this.urlTemporaryParams = params;
                }
            }
        });
        Object.defineProperty(this, "changeUrlTempParam", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (placeholderIndex, value) => {
                const params = [...this.urlTemporaryParams];
                params[placeholderIndex] = value;
                this.urlTemporaryParams = params;
            }
        });
        Object.defineProperty(this, "setTempExampleParam", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                var _a;
                const altValue = Array((_a = this.templateMessage.match(/{{(.*?)}}/g)) === null || _a === void 0 ? void 0 : _a.length);
                this.bodyExampleTemporaryParams = value || altValue;
                if (this.callToActionButtons) {
                    this.callToActionButtons.forEach((button, buttonIndex) => {
                        if (button.type === CALL_TO_ACTION_TYPES.URL && button.url && /{{(\d+)}}/.test(button.url)) {
                            const match = button.url.match(/{{(\d+)}}/);
                            if (match) {
                                const placeholderNum = parseInt(match[1], 10);
                                const existingExample = this.callToActionButtonUrlExamples[buttonIndex];
                                if (existingExample) {
                                    this.urlTemporaryParams[placeholderNum - 1] = existingExample;
                                }
                            }
                        }
                    });
                }
            }
        });
        Object.defineProperty(this, "setTemplateExamples", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (examples) => {
                this.bodyExampleParams = examples.filter(e => !isNil(e));
                if (this.callToActionButtons) {
                    this.callToActionButtons.forEach((button, buttonIndex) => {
                        if (button.type === CALL_TO_ACTION_TYPES.URL && button.url && /{{(\d+)}}/.test(button.url)) {
                            const match = button.url.match(/{{(\d+)}}/);
                            if (match) {
                                const placeholderNum = parseInt(match[1], 10);
                                const urlExample = this.urlTemporaryParams[placeholderNum - 1];
                                if (urlExample) {
                                    this.callToActionButtonUrlExamples[buttonIndex] = urlExample;
                                }
                            }
                        }
                    });
                }
            }
        });
        Object.defineProperty(this, "clearRichParams", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.richTemplateHeader = null;
                this.richTemplateHeaderType = null;
                this.richTemplateHeaderUrl = constants.DEFAULT_EXAMPLE_TEMPLATE_IMG_URL;
                this.richTemplateFooter = null;
                this.richTemplateButtonType = null;
                this.quickReplyButtons = null;
                this.callToActionButtons = null;
                this.callToActionButtonUrlExamples = [];
                this.bodyExampleParams = [];
            }
        });
        Object.defineProperty(this, "showCancelNotifyModal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (state) => {
                this.showManagerCancelModal = state;
            }
        });
        Object.defineProperty(this, "setSelectedAccount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (account) => {
                this.selectedAccountId = account;
            }
        });
        Object.defineProperty(this, "syncAndLoadTemplateMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (accountId) => __awaiter(this, void 0, void 0, function* () {
                yield this.syncTemplateMessages(accountId).catch(err => {
                    console.error('Error syncing templates', err);
                });
                yield this.loadTemplateMessages(accountId).catch(err => {
                    console.error('Error loading templates', err);
                });
                yield this.getTierLimit().catch(err => {
                    console.error('Error getting tier limit', err);
                });
            })
        });
        Object.defineProperty(this, "setIsDefaultTemplate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (isDefault) => {
                this.isDefaultTemplate = isDefault;
            }
        });
        /**
         * It not very clear why this function exists
         *
         * @param templateMessage
         */
        Object.defineProperty(this, "parseTemplate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (templateMessage) => {
                var _a, _b, _c;
                if (templateMessage.provider_template.localizations.filter(Boolean).length === 0) {
                    const language = Object.keys(templateMessage.localizationDrafts || {})[0];
                    if (language && templateMessage.localizationDrafts) {
                        templateMessage.provider_template.localizations = [templateMessage.localizationDrafts[language]];
                    }
                }
                const localization = templateMessage.provider_template.localizations[0];
                const status = localization.status;
                const title = templateMessage.title;
                const name = templateMessage.name;
                const usage = templateMessage.usage;
                const chatStatus = templateMessage.chatStatus;
                const setBotNode = templateMessage.setBotNode;
                const bot = templateMessage.bot;
                const replyText = templateMessage.replyText;
                const category = templateMessage.provider_template.category;
                const departments = templateMessage.departments;
                const rejectionReason = templateMessage.provider_template.localizations[0].rejectionReason;
                const responsibleAgent = templateMessage.responsibleAgent;
                const responsibleDepartment = templateMessage.responsibleDepartment;
                const attachedFile = templateMessage.attachedFile;
                const updatedAt = new Date(templateMessage.updatedAt);
                const createdAt = new Date(templateMessage.created);
                const isDefault = templateMessage.isDefault;
                const defaultHeader = (_b = (_a = templateMessage.defaults) === null || _a === void 0 ? void 0 : _a[localization.language]) === null || _b === void 0 ? void 0 : _b.header;
                // Provider example handles are not publicly downloadable (Cloud API returns its own CDN URL),
                // so prefer the re-hosted default the server stores for us
                const defaultMediaHeaderUrl = defaultHeader && defaultHeader.type !== WhatsApp.TemplateHeaderSendType.TEXT
                    ? defaultHeader.url
                    : undefined;
                let bodyExampleParams;
                let header;
                let footer;
                let buttons;
                let text;
                templateMessage.provider_template.localizations[0].components.forEach(component => {
                    var _a, _b, _c;
                    if (component.type === WhatsApp.TemplateComponentType.HEADER) {
                        const url = [WhatsApp.TemplateComponentFormat.DOCUMENT, WhatsApp.TemplateComponentFormat.IMAGE, WhatsApp.TemplateComponentFormat.VIDEO].includes(component.format)
                            ? defaultMediaHeaderUrl !== null && defaultMediaHeaderUrl !== void 0 ? defaultMediaHeaderUrl : (_b = (_a = component === null || component === void 0 ? void 0 : component.example) === null || _a === void 0 ? void 0 : _a.header_handle) === null || _b === void 0 ? void 0 : _b[0]
                            : null;
                        header = {
                            type: component.format,
                            text: component.format === WhatsApp.TemplateComponentFormat.TEXT ? component.text : null,
                            url,
                            filename: component.format === WhatsApp.TemplateComponentFormat.DOCUMENT &&
                                (defaultHeader === null || defaultHeader === void 0 ? void 0 : defaultHeader.type) === WhatsApp.TemplateHeaderSendType.DOCUMENT &&
                                defaultHeader.url === url
                                ? defaultHeader.filename
                                : undefined,
                        };
                    }
                    if (component.type === WhatsApp.TemplateComponentType.BODY) {
                        text = component.text;
                        if (component.example) {
                            bodyExampleParams = (_c = component.example.body_text) === null || _c === void 0 ? void 0 : _c[0];
                        }
                    }
                    if (component.type === WhatsApp.TemplateComponentType.FOOTER) {
                        footer = component;
                    }
                    if (component.type === WhatsApp.TemplateComponentType.BUTTONS) {
                        buttons = {
                            type: component.buttons[0] ? component.buttons[0].type : null,
                            buttons: component.buttons
                        };
                    }
                });
                return {
                    _id: templateMessage._id,
                    header,
                    text,
                    footer,
                    buttons,
                    language: localization.language,
                    obj: templateMessage.provider_template,
                    title: title || "",
                    status,
                    rejectionReason,
                    usage,
                    departments,
                    category,
                    name,
                    chatStatus,
                    setBotNode,
                    bot,
                    replyText,
                    responsibleAgent,
                    responsibleDepartment,
                    attachedFile,
                    updatedAt,
                    createdAt,
                    bodyExampleParams,
                    isDefault,
                    localizationEdits: (_c = templateMessage.localizationEdits) === null || _c === void 0 ? void 0 : _c[localization.language],
                };
            }
        });
        makeObservable(this);
        this.rootStore = rootStore;
        this.rootStore.events
            .addListener(EventName.template_updated, (data) => this.onTemplateUpdatedEvent(data))
            .addListener(EventName.template_deleted, (data) => this.onTemplateDeletedEvent(data));
        reaction(() => { var _a; return (_a = this.selectedAccountId) === null || _a === void 0 ? void 0 : _a.id; }, () => {
            const { id, name } = this.selectedAccountId || {};
            if (id && name === MessagingChannel.whatsapp) {
                this.syncAndLoadTemplateMessages(id);
            }
        });
        reaction(() => this.hasAllSampleParamsAdded, (hasAllSampleParamsAdded) => {
            var _a;
            // if template is not approved yet, then check if all sample params have been added
            if (((_a = this.currentTemplate) === null || _a === void 0 ? void 0 : _a.status) !== WhatsApp.Templates.Localizations.Status.APPROVED) {
                this.handleCheckIfSampleParamsHaveBeenAdded(hasAllSampleParamsAdded);
            }
        });
    }
    get hasSampleParamsSetup() {
        var _a;
        const regex = /{{\d}}/g; // {{1}} any digit within double curly braces
        return (_a = this.templateMessage) === null || _a === void 0 ? void 0 : _a.match(regex);
    }
    get hasDocumentSample() {
        return this.richTemplateHeaderType === TEMPLATE_HEADER_TYPE.DOCUMENT && (this.richTemplateHeader instanceof File ||
            !!this.richTemplateHeaderUrl &&
                this.richTemplateHeaderUrl !== constants.DEFAULT_EXAMPLE_TEMPLATE_IMG_URL);
    }
    get richTemplateDocumentFilename() {
        var _a, _b;
        if (this.richTemplateHeader instanceof File) {
            return this.richTemplateHeader.name;
        }
        return ((_b = (_a = this.currentTemplate) === null || _a === void 0 ? void 0 : _a.header) === null || _b === void 0 ? void 0 : _b.url) === this.richTemplateHeaderUrl
            ? this.currentTemplate.header.filename
            : undefined;
    }
    get hasAtLeastOneSampleParamAdded() {
        const hasParams = (this.bodyExampleParams || []).filter((p) => p !== '').length > 0;
        const hasHeader = !!this.richTemplateHeaderUrl;
        return hasParams || hasHeader;
    }
    get hasAllSampleParamsAdded() {
        const hasBodyParams = () => {
            var _a;
            if (!this.hasSampleParamsSetup)
                return true;
            return ((_a = this.bodyExampleParams) === null || _a === void 0 ? void 0 : _a.filter((p) => p !== '').length) >= this.nextPlaceholderNumber - 1;
        };
        const hasHeaderParams = () => {
            if (!this.richTemplateHeaderType)
                return true;
            if ([TEMPLATE_HEADER_TYPE.IMAGE, TEMPLATE_HEADER_TYPE.DOCUMENT, TEMPLATE_HEADER_TYPE.VIDEO].includes(this.richTemplateHeaderType)) {
                if (this.richTemplateHeader)
                    return true;
                return !!this.richTemplateHeaderUrl && this.richTemplateHeaderUrl !== constants.DEFAULT_EXAMPLE_TEMPLATE_IMG_URL;
            }
            return true;
        };
        const hasUrlParams = () => {
            if (!this.callToActionButtons)
                return true;
            for (let i = 0; i < this.callToActionButtons.length; i++) {
                const button = this.callToActionButtons[i];
                if (button.type === CALL_TO_ACTION_TYPES.URL && button.url && /{{.*?}}/.test(button.url)) {
                    if (!this.callToActionButtonUrlExamples[i] || this.callToActionButtonUrlExamples[i].trim() === '') {
                        return false;
                    }
                }
            }
            return true;
        };
        return hasBodyParams() && hasHeaderParams() && hasUrlParams();
    }
    get allTemplateParams() {
        var _a;
        const bodyParams = [];
        const urlParams = [];
        // Add body parameters
        if (this.hasSampleParamsSetup) {
            const bodyPlaceholders = (_a = this.templateMessage.match(/{{(\d+)}}/g)) !== null && _a !== void 0 ? _a : [];
            bodyPlaceholders.forEach((placeholder, index) => {
                var _a;
                const placeholderNum = parseInt(((_a = placeholder.match(/\d+/)) === null || _a === void 0 ? void 0 : _a[0]) || '0');
                bodyParams.push({
                    type: 'body',
                    index,
                    placeholder,
                    placeholderNum,
                    value: this.bodyExampleTemporaryParams[index] || ''
                });
            });
        }
        // Add URL parameters
        if (this.callToActionButtons) {
            this.callToActionButtons.forEach((button, buttonIndex) => {
                var _a, _b;
                if (button.type === CALL_TO_ACTION_TYPES.URL && button.url && /{{(\d+)}}/.test(button.url)) {
                    const urlPlaceholder = (_a = button.url.match(/{{(\d+)}}/)) === null || _a === void 0 ? void 0 : _a[0];
                    if (urlPlaceholder) {
                        const placeholderNum = parseInt(((_b = urlPlaceholder === null || urlPlaceholder === void 0 ? void 0 : urlPlaceholder.match(/\d+/)) === null || _b === void 0 ? void 0 : _b[0]) || '0');
                        urlParams.push({
                            type: 'url',
                            index: buttonIndex,
                            placeholder: urlPlaceholder,
                            placeholderNum,
                            value: this.urlTemporaryParams[placeholderNum - 1] || ''
                        });
                    }
                }
            });
        }
        bodyParams.sort((a, b) => a.placeholderNum - b.placeholderNum);
        return [...bodyParams, ...urlParams];
    }
    get account() {
        const account = this.rootStore.channels.accounts.find((acc) => { var _a; return acc.accountId === ((_a = this.selectedAccountId) === null || _a === void 0 ? void 0 : _a.id); });
        if (account) {
            return account;
        }
        return { accountId: '' };
    }
    get defaultTemplate() {
        var _a, _b;
        const accountId = (_a = this.selectedAccountId) === null || _a === void 0 ? void 0 : _a.id;
        if (!accountId)
            return null;
        const template = (_b = this.templateMessagesLists[accountId]) === null || _b === void 0 ? void 0 : _b.find((tmp) => tmp.isDefault);
        if (template) {
            return template;
        }
        return null;
    }
    get templateMessagesList() {
        if (!this.selectedAccountId)
            return [];
        return this.templateMessagesLists[this.selectedAccountId.id] || [];
    }
    get selectedChannelBot() {
        var _a;
        const account = this.selectedAccountId ? this.rootStore.channels.getAccount(this.selectedAccountId) : null;
        return (_a = account === null || account === void 0 ? void 0 : account.bot) !== null && _a !== void 0 ? _a : null;
    }
    /** Template localization was already submitted to WhatsApp */
    get isTemplateSubmitted() {
        var _a;
        const status = (_a = this.currentTemplate) === null || _a === void 0 ? void 0 : _a.status;
        return !!status && status !== 'NEW';
    }
    get canEditSubmittedLocalizations() {
        var _a, _b;
        const accountId = (_a = this.selectedAccountId) === null || _a === void 0 ? void 0 : _a.id;
        return !!accountId && !!((_b = this.whatsAppFeatures[accountId]) === null || _b === void 0 ? void 0 : _b.includes(WhatsApp.Feature.templateLocalizationEditable));
    }
    /** Unix ms until approved localization reached WhatsApp edits limit */
    get localizationEditBlockedUntil() {
        var _a;
        if (((_a = this.currentTemplate) === null || _a === void 0 ? void 0 : _a.status) !== WhatsApp.Templates.Localizations.Status.APPROVED
            || !this.currentTemplate.localizationEdits) {
            return null;
        }
        return WhatsApp.Templates.Localizations.calculateNextAllowedEditTimestamp(this.currentTemplate.localizationEdits, Date.now());
    }
    get isLocalizationEditable() {
        var _a, _b;
        if (!this.isTemplateSubmitted)
            return true;
        return this.canEditSubmittedLocalizations
            && WhatsApp.Templates.Localizations.isEditableStatus((_b = (_a = this.currentTemplate) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : '')
            && this.localizationEditBlockedUntil === null;
    }
    get contentFieldsBlocked() {
        return !this.isLocalizationEditable;
    }
    get categoryAndLanguageBlocked() {
        return this.isTemplateSubmitted;
    }
    get hasContentChanges() {
        if (this.contentSnapshot === null)
            return false;
        return this.richTemplateHeader instanceof File || JSON.stringify(this.createRichTemplateParams()) !== this.contentSnapshot;
    }
    get canSubmitToWhatsApp() {
        if (!this.currentTemplate)
            return false;
        if (!this.isTemplateSubmitted)
            return true;
        return this.isLocalizationEditable && this.hasContentChanges;
    }
    /** Content changes of submitted template can be saved only by submitting them to WhatsApp */
    get canSaveTemplate() {
        return !(this.isTemplateSubmitted && this.hasContentChanges);
    }
    get editBannerState() {
        var _a;
        if (((_a = this.currentTemplate) === null || _a === void 0 ? void 0 : _a.status) !== WhatsApp.Templates.Localizations.Status.APPROVED || !this.canEditSubmittedLocalizations)
            return null;
        return this.localizationEditBlockedUntil === null ? 'editable' : 'cooldown';
    }
    onTemplateUpdatedEvent(tmplUpdated) {
        var _a, _b;
        const { accountId } = tmplUpdated.channelInfo;
        // re-casting it to get the _id property, probably something to consider changing in the lib
        const newTemplate = tmplUpdated;
        const templateExists = (_a = this.templateMessagesLists[accountId]) === null || _a === void 0 ? void 0 : _a.find((tmpl) => tmpl._id === newTemplate._id);
        if (!templateExists) {
            this.templateMessagesLists[accountId] = [
                this.parseTemplate(newTemplate),
                ...(this.templateMessagesLists[accountId] || []),
            ];
        }
        else {
            this.templateMessagesLists[accountId] =
                (_b = this.templateMessagesLists[accountId]) === null || _b === void 0 ? void 0 : _b.map((tmpl) => {
                    return newTemplate._id === tmpl._id ? this.parseTemplate(newTemplate) : tmpl;
                });
        }
    }
    onTemplateDeletedEvent(data) {
        Object.entries(this.templateMessagesLists).forEach(([accountId, templates]) => {
            this.templateMessagesLists[accountId] = templates.filter((tmpl) => tmpl._id !== data._id);
        });
    }
}
__decorate([
    observable
], TemplateMessagesStore.prototype, "templateMessagesLists", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "templateMessagesLoading", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "isNewTemplateDrawer", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "templateTitle", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "templateName", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "templateUsage", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "templateDepartments", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "templateLanguage", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "templateCategory", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "templateMessage", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "nextPlaceholderNumber", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "currentTemplate", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "templateEditing", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "templateCreating", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "templateDeleting", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "templateChatStatus", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "templateChatRadioStatus", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "setBotNode", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "selectedBotIdentifier", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "templateReplyText", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "templateReplyActionDuration", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "responsibleAgent", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "responsibleDepartment", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "attachedFile", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "botNodeLists", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "botNodeListLoading", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "templateFieldMissing", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "isDefaultTemplate", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "submitTemplateLoading", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "submitTemplateError", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "submitWhatsAppLoading", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "submitWhatsAppError", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "richTemplateHeader", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "richTemplateHeaderType", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "richTemplateHeaderUrl", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "richTemplateFooter", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "richTemplateButtonType", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "quickReplyButtons", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "callToActionButtons", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "callToActionButtonUrlExamples", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "bodyExampleParams", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "bodyExampleTemporaryParams", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "urlTemporaryParams", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "showManagerCancelModal", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "contentSnapshot", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "whatsAppFeatures", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "templateTierLimitCount", void 0);
__decorate([
    observable
], TemplateMessagesStore.prototype, "selectedAccountId", void 0);
__decorate([
    computed
], TemplateMessagesStore.prototype, "hasSampleParamsSetup", null);
__decorate([
    computed
], TemplateMessagesStore.prototype, "hasDocumentSample", null);
__decorate([
    computed
], TemplateMessagesStore.prototype, "richTemplateDocumentFilename", null);
__decorate([
    computed
], TemplateMessagesStore.prototype, "hasAtLeastOneSampleParamAdded", null);
__decorate([
    computed
], TemplateMessagesStore.prototype, "hasAllSampleParamsAdded", null);
__decorate([
    computed
], TemplateMessagesStore.prototype, "allTemplateParams", null);
__decorate([
    computed
], TemplateMessagesStore.prototype, "account", null);
__decorate([
    computed
], TemplateMessagesStore.prototype, "defaultTemplate", null);
__decorate([
    computed
], TemplateMessagesStore.prototype, "templateMessagesList", null);
__decorate([
    computed
], TemplateMessagesStore.prototype, "selectedChannelBot", null);
__decorate([
    computed
], TemplateMessagesStore.prototype, "isTemplateSubmitted", null);
__decorate([
    computed
], TemplateMessagesStore.prototype, "canEditSubmittedLocalizations", null);
__decorate([
    computed
], TemplateMessagesStore.prototype, "localizationEditBlockedUntil", null);
__decorate([
    computed
], TemplateMessagesStore.prototype, "isLocalizationEditable", null);
__decorate([
    computed
], TemplateMessagesStore.prototype, "contentFieldsBlocked", null);
__decorate([
    computed
], TemplateMessagesStore.prototype, "categoryAndLanguageBlocked", null);
__decorate([
    computed
], TemplateMessagesStore.prototype, "hasContentChanges", null);
__decorate([
    computed
], TemplateMessagesStore.prototype, "canSubmitToWhatsApp", null);
__decorate([
    computed
], TemplateMessagesStore.prototype, "canSaveTemplate", null);
__decorate([
    computed
], TemplateMessagesStore.prototype, "editBannerState", null);
__decorate([
    action
], TemplateMessagesStore.prototype, "fetchBotNodeList", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "sendTemplateMessage", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "createTemplate", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "toggleNewTemplateDrawer", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "handleEditTemplate", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "handleDeleteTemplate", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "handleSubmitToWhatsApp", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "saveAndSubmitToWhatsApp", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "setResponsibleAgentOrDepartment", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "setAttachedFile", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "setNewTemplate", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "setTemplateEdited", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "setTemplateDeleting", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "handleSetUsage", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "handleSetTemplateLanguage", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "handleSetCategory", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "handleSetDepartment", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "handleCheckIfSampleParamsHaveBeenAdded", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "handleSetMessage", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "handleAddPlaceholder", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "handleAddEmoji", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "handleSetTitle", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "setTemplateName", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "handleSetStatus", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "setTemplateReplyActionDuration", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "handleSetRadioStatus", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "handleSetBotNode", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "handleSelectBot", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "applyBotToReplySettings", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "handleSetReplyText", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "addEmojiToReply", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "setStoreToDefault", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "setFieldError", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "handleRichTemplateHeaderType", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "handleSetHeader", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "clearRichTemplateHeaderFile", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "handleSetFooter", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "handleSetButtonType", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "handleAddButton", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "handleRemoveButton", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "handleButtonTextChange", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "handleAddPlaceholderToUrl", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "handleSetUrlExample", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "changeTempExampleParam", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "changeConsolidatedParam", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "changeUrlTempParam", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "setTempExampleParam", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "setTemplateExamples", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "clearRichParams", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "showCancelNotifyModal", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "setSelectedAccount", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "setIsDefaultTemplate", void 0);
__decorate([
    action
], TemplateMessagesStore.prototype, "onTemplateUpdatedEvent", null);
__decorate([
    action
], TemplateMessagesStore.prototype, "onTemplateDeletedEvent", null);
export default TemplateMessagesStore;
